export default __webpack_public_path__ + "static/media/py.2b5f06c4.png";